

import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import _cloneDeep from 'lodash/cloneDeep';
import { CategoryConfig, QuestionConfig } from './../models/config.model';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, OnChanges, Output, ViewEncapsulation, SimpleChanges } from "@angular/core";
import { ToastrService } from 'ngx-toastr';
import { showToast } from '../../toast.helper';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { FormioLoader, ResourceNameService } from 'dp-formio';

declare var $: any;

@Component({
    selector: 'app-optional-inputs',
    templateUrl: './optional-inputs.component.html',
    // styleUrls: ['./optional-inputs.component.scss']
    encapsulation: ViewEncapsulation.None,
    providers: [FormioLoader]
})
export class OptionalInputsComponent implements OnInit, OnDestroy {
    @Input() orginalCategory: CategoryConfig | any;
    @Input() categoryHasChanged: EventEmitter<CategoryConfig>;
    @Input() customOptions: any;
    @Input() viewOnly: boolean;
    @Output() data = new EventEmitter<any[]>();
    @Output() changeCategory = new EventEmitter<any>();
    sub: Subscription;

    showForm = true;
    formReady = true;

    category: CategoryConfig;
    private defaultEditorValue = '<p class="ql-align-right"><br></p>';

    constructor(private resourceNameService: ResourceNameService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private cdr: ChangeDetectorRef,
        private formioLoader: FormioLoader) {
        this.formioLoader.loading = false;
        //TODO : we need to refactor validation to reactive 
    }

    ngOnInit() {
        this.category = _cloneDeep(this.orginalCategory);
        
        this.category?.attachments?.forEach(q => q.data?.length > 0 ? true : q.data=[]);
        
        console.log('this.category',this.category);
        this.sub = this.categoryHasChanged.subscribe((category) => {
            this.orginalCategory = _cloneDeep(category);
            this.category = _cloneDeep(category);
            this.category?.attachments?.forEach(q => q.data = []);
            
        });
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }

    addOptionalInput(optionalInput) {
        optionalInput.results.push({ value: '' });
        this.data.emit(optionalInput.results);
    }

    removeOptionalInput(optionalInput, i) {
        optionalInput.results.splice(i, 1);
        this.data.emit(optionalInput.results);
    }
    changeValue(optionalInput) {
        this.data.emit(optionalInput.results);
    }

    saveCategory() {
        this.formioLoader.loading = true;
        console.log('this.category',this.category)
        if(!Array.isArray(this.category?.attachments)){
            this.category.attachments=[];
        }


        this.sub = this.resourceNameService.editSubmission(this.customOptions.categoryResource,
            this.category._id, { data: this.mapCategory() })
            .subscribe(data => {
                this.formioLoader.loading = false;
                this.orginalCategory.optionalInputs = this.category.optionalInputs;
                this.orginalCategory.descriptionStandardResult = this.category.descriptionStandardResult;
                this.orginalCategory.pledgeValue = this.category.pledgeValue;
                this.orginalCategory.attachments = this.category.attachments;
                this.changeCategory.emit(this.orginalCategory);
                showToast(this.toastrService,
                    this.translateService.instant("forms.common.Saved done"),
                    this.translateService.instant("forms.common.Saved Successfully"),
                    false
                );
            }, error => {
                this.formioLoader.loading = false;
                showToast(this.toastrService,
                    this.translateService.instant("ErrorOccurred"),
                    this.translateService.instant("generalError"),
                    true
                );
            });
    }

    changeApply() {
        this.showForm = false;
        this.formReady = false;
        setTimeout(() => this.formReady = true);
    }
    formLoad(formSettings) {
        setTimeout(() => {
            const array = $('.optionalInputs [name="data[submit]"]');
            for (let index = 0; index < array.length; index++) {
                $(array[index]).hide();
            }
            this.showForm = true;
        }, 250);
    }

    get isDescriptionStandardResultValid() {
        if (this.category?.isDescriptionStandardRequired)
            return !!this.category.descriptionStandardResult && this.category.descriptionStandardResult != this.defaultEditorValue;
        else return true;
    }
    get isOptionalInputsValid() {
        return true;
        // console.log('this.category.optionalInputs',this.category.optionalInputs)
        var tempOptionalInputs = this.category.optionalInputs.filter(q=>!q.nameAr.includes("الرأي المستقل"))
        // console.log('this.category.optionalInputs XX',xx)
        return tempOptionalInputs?.length &&
        tempOptionalInputs.every(q => q.results?.filter(r => !!r.value)?.length >= 1);
    }

    get isPledgeResultValid() {
        if (this.category?.pledgeIsRequired)
            return this.category.pledgeValue;
        else return true;
    }

    private mapCategory() {
        const category = _cloneDeep(this.category);
        delete category.processConfigObject;
        delete category.parentCategoryObject;
        delete category.subCategoriresObject;
        delete category.questionsAssessmentObject;
        delete category._id;
        return category;
    }
}
